import type { FC } from 'react';
import React from 'react';

import { Box, Typography, useTheme } from '@mui/material';

import type { TypographyOwnProps } from '@mui/material';
import type { IconPropertyPropsType } from '@shared/ui/containers/PropertyViewerContainer/types';

type BaseFieldViewProps = {
  label?: string;
  labelVariant?: TypographyOwnProps['variant'];
  labelColor?: string;
  value?: string | number | null;
  valueVariant?: TypographyOwnProps['variant'];
  valueColor?: string | null;
  startIcon?: Partial<IconPropertyPropsType>;
  endIcon?: Partial<IconPropertyPropsType>;
  noWrapValue?: boolean;
  startComponent?: React.ReactNode | null;
  isFullWidth?: boolean;
};
const BaseFieldView: FC<BaseFieldViewProps> = ({
  label,
  labelVariant,
  labelColor,
  value,
  valueVariant,
  valueColor,
  startIcon,
  startComponent,
  isFullWidth = true,
  endIcon,
  noWrapValue,
}) => {
  const theme = useTheme();

  return (
    <Box display="flex" flexDirection="column" width={isFullWidth ? '100%' : 'auto'}>
      {label && (
        <Typography color={labelColor || theme.palette.case.neutral.n500} variant={labelVariant || 't12r'}>
          {label}
        </Typography>
      )}

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          marginTop: '2px',
          ...(startIcon?.sxCustom || endIcon?.sxCustom),
        }}
      >
        {startComponent && startComponent}
        {startIcon?.icon && <Box sx={{ alignSelf: 'baseline' }}>{startIcon?.icon}</Box>}
        <Typography
          color={valueColor || theme.palette.case.neutral.n800}
          sx={{ wordBreak: 'break-word' }}
          variant={valueVariant || 't14r'}
          noWrap={noWrapValue}
        >
          {value ? value : '––'}
        </Typography>
        {endIcon?.icon && <Box>{endIcon?.icon}</Box>}
      </Box>
    </Box>
  );
};

export default BaseFieldView;
